<style lang="scss" scoped>
#postback-help-table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}
#postback-help-table > tr > td,
#postback-help-table > tr > th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}
#postback-help-table > tr:nth-child(even) {
  background-color: #dddddd;
}
textarea {
  min-height: 14rem;
}
</style>

<template>
  <div class="card">
    <div class="card-header">
      <h4>Affiliate-Postback erstellen</h4>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <i class="fas fa-question-circle text-info"></i> Bei einer
              Registrierung muss die externe ID (<code>eid</code>) zusammen mit
              der entsprechenden Werbe ID <code>ac</code> angegeben werden.
              Diese beiden Paramater können über das Frontend mittels
              GET-Parameter übergeben werden. Diese beiden Parameter werden dann
              dauerhaft in der Session gespeichert und bleiben für diese Session
              gültig; Müssen also nur zur Not ein einziges Mal angegeben werden.
              Im Falle einer externen Registrierung durch die API müssen diese
              Parameter (<code>ac</code> und <code>eid</code>) mit als POST mit
              angegeben werden.
            </div>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <col-label>Type</col-label>
        <div class="col-8">
          <select
            class="custom-select"
            id="postback-type-selector"
            v-model="postback.type"
            placeholder="Type wählen"
          >
            <option
              v-for="(type, index) in typeOptions"
              :value="type.value"
              :key="index"
              >{{ type.text }}</option
            >
          </select>
        </div>
      </div>
      <div class="form-group row">
        <col-label>Werbung ID</col-label>
        <div class="col-8">
          <select
            class="custom-select"
            id="postback-affiliate-selector"
            v-model="postback.affiliateId"
            placeholder="Werbekampagne wählen"
          >
            <option
              v-for="(affiliate, index) in affiliates"
              :value="affiliate.value"
              :key="index"
              >{{ affiliate.text }}</option
            >
          </select>
        </div>
      </div>
      <div class="form-group row">
        <col-label>Event</col-label>
        <div class="col-8">
          <select
            class="custom-select"
            id="postback-event-trigger-selector"
            v-model="postback.triggerEvent"
            placeholder="Trigger-Event wählen"
          >
            <option
              v-for="(trigger, index) in triggerEventOptions"
              :value="trigger.value"
              :key="index"
              >{{ trigger.text }}</option
            >
          </select>
        </div>
      </div>
      <div class="form-group row">
        <br />
        <col-label>URL-Attribute</col-label>
        <div class="col-4">
          <table id="postback-help-table">
            <tr>
              <th class="col-2">Wert</th>
              <th class="col-1">Platzhalter</th>
            </tr>
            <tr>
              <td>User ID</td>
              <td>|uid|</td>
            </tr>
            <tr>
              <td>User Email-Adresse</td>
              <td>|email|</td>
            </tr>
            <tr>
              <td>User Extern-ID</td>
              <td>|eid|</td>
            </tr>
            <tr>
              <td>Geldbetrag (in € cent)</td>
              <td>|amount|</td>
            </tr>
            <tr>
              <td>Geldbetrag (in €)</td>
              <td>|amount_de|</td>
            </tr>
            <tr>
              <td>Geldbetrag (in $)</td>
              <td>|amount_us|</td>
            </tr>
            <tr>
              <td>Werbe ID</td>
              <td>|aid|</td>
            </tr>
            <tr>
              <td>Tracking-Code (der Kampagne)</td>
              <td>|code|</td>
            </tr>
            <tr>
              <td>Domain</td>
              <td>|domain|</td>
            </tr>
            <tr>
              <td>IP</td>
              <td>|ip|</td>
            </tr>
            <tr>
              <td>Zeitpunkt in Unixtime inkl. Millisekunde</td>
              <td>|microtime|</td>
            </tr>
            <tr>
              <td>Zeitpunkt Unixtime</td>
              <td>|time|</td>
            </tr>
            <tr>
              <td>Datum und Uhrzeit (<code>date('Y-m-d H:i:s')</code>)</td>
              <td>|datetime|</td>
            </tr>
            <tr>
              <td>
                Datum und Uhrzeit deutsches Format (<code
                  >date('d.m.Y H:i:s')</code
                >)
              </td>
              <td>|datetime_deu|</td>
            </tr>
            <tr>
              <td>Eineindeutige ID, benutzt <code>uniqid()</code></td>
              <td>|uuid|</td>
            </tr>
            <tr>
              <td>Zufallszahl zwischen 0 und 2147483647</td>
              <td>|rand|</td>
            </tr>
            <tr>
              <td>Rechnungsnummer, <b>nur</b> bei Event Kauf, sonst NULL</td>
              <td>|invoice_nr|</td>
            </tr>
            <tr>
              <td>Bei Registrierung zusätzlich übergebener Parameter</td>
              <td>|parameter['<i>VALUE</i>']|</td>
            </tr>
          </table>

          <br />
        </div>
      </div>
      <div class="form-group row" v-if="isURLPostback">
        <col-label>Postback-URL</col-label>
        <div class="col-8">
          <input
            type="text"
            class="form-control"
            v-model="postback.postback"
            placeholder="http://domain.tld/postback?"
          />
        </div>
      </div>
      <div class="form-group row" v-else>
        <col-label>Postback-Script</col-label>
        <div class="col-8">
          <textarea
            class="form-control"
            v-model="postback.postback"
            rows="18"
            placeholder="<script></script>"
          ></textarea>
        </div>
      </div>
    </div>
    <div class="col-11">
      <v-button @click="persist()" class="btn btn-primary float-right"
        >Speichern</v-button
      >
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    isURLPostback() {
      return this.postback.type == 0 ? true : false;
    }
  },
  methods: {
    persist() {
      this.$http
        .post("/api/v1/postback/", {
          type: this.postback.type,
          affiliate_id: this.postback.affiliateId,
          postback: this.postback.postback,
          trigger_event: this.postback.triggerEvent
        })
        .then(() => {
          this.$notify({
            title: "Postback gespeichert",
            type: "success"
          });
          this.$router.push("/werbungsverfolgung/liste");
        })
        .catch(error => {
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            this.$notify({
              title: error.response.data.message,
              type: "error"
            });
          }
        });
    },
    getAffiliates() {
      return this.$http
        .get("/api/v1/affiliate/postbackRead")
        .then(({ data }) => {
          for (const [value, text] of Object.entries(data)) {
            this.affiliates.push({ value: value, text: value + " - " + text });
          }
          this.affiliates.reverse();
        });
    }
  },
  created() {
    this.getAffiliates();
  },
  data() {
    return {
      affiliates: [],
      postback: {
        type: 0,
        affiliateId: "Werbekampagne wählen",
        postback: "",
        triggerEvent: 0
      },
      triggerEventOptions: [
        {
          value: 0,
          text: "SOI -> Pay per Lead (CPL)"
        },
        {
          value: 1,
          text: "DOI -> Pay per Lead (CPL)"
        },
        {
          value: 2,
          text: "beim ersten Kauf (einmalig) -> Pay per Sale(CPO)"
        },
        {
          value: 3,
          text: "bei jedem Kauf -> Pay per Sale(CPO)"
        },
        {
          value: 4,
          text: "nur Besuch"
        }
      ],
      typeOptions: [
        {
          value: 0,
          text: "S2S / Curl / HTTP(s) aufruf "
        },
        {
          value: 1,
          text: "Tracking HTML/Javascript"
        }
      ]
    };
  }
};
</script>
